import { render, staticRenderFns } from "./ProfileFields.vue?vue&type=template&id=637b0f74&scoped=true&"
import script from "./ProfileFields.vue?vue&type=script&lang=ts&"
export * from "./ProfileFields.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileFields.vue?vue&type=style&index=0&id=637b0f74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b0f74",
  null
  
)

export default component.exports